import UserComponent from "../components/userComponent";

import useUser from "../hook/useUser";
import useProduct from "../hook/useProduct";

const UserPage = ({

}) => {
    const user = useUser();
    const footerMenu = useProduct();
    return <UserComponent {...user} {...footerMenu} />
}
export default UserPage;